<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "app",

    computed: {
        ...mapState("i18n", ["locale"]),
    },

    data() {
        return {
            lastScrollPosition: 0,
        };
    },
    methods: {},
    mounted() {
        // detect preferred user languages, then set i18n accordingly
        const store = this.$store;
        const navigatorLanguage = navigator.language.substring(0, 2);
        const availableLocales = new Set(["de", "en"]);
        const navigatorLanguages = navigator.languages
            ? navigator.languages
            : [];
        const preferredLanguages = navigatorLanguages
            .map((l) => {
                return l.substring(0, 2);
            })
            .reverse();

        // check first if language was previously set manually
        let locale = sessionStorage.getItem("manuallySetLocale");
        if (locale && availableLocales.has(locale)) {
            store.commit("i18n/setLocale", locale);
            store.commit("i18n/setLocaleSetByBrowserPreference", false);
            this.$i18n.locale = locale;
        }
        // otherwise, use preferred browser language
        else {
            locale = preferredLanguages.reduce((acc, lang) => {
                if (availableLocales.has(lang)) {
                    acc = lang;
                }
                return acc;
            }, navigatorLanguage);
            if (
                availableLocales.has(locale) &&
                !store.state.i18n.localeSetByBrowserPreference
            ) {
                store.commit("i18n/setLocale", locale);
                store.commit("i18n/setLocaleSetByBrowserPreference", true);
                this.$i18n.locale = locale;
            } else {
                // default locale is set in constructor of i18n via vuex store's default value
            }
        }
    },

    watch: {
        locale(newValue) {
            this.$i18n.locale = newValue;
        },
    },
};
</script>
